import { createContext, useEffect, useState } from "react";

export const config = createContext();

export default function Configuration({children}) {
    const api = process.env.REACT_APP_API_URL;
    const [devKey, setDevKey] = useState(localStorage.getItem("dev_id_sys") || "");
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem("lang") || "en";
    });
    const lessVisaMoney = 100;
    const [stylingNav, setStylingNav] = useState(false);
    const [page, setPage] = useState(1);
    const [tablesAreCreates, setTablesAreCreated] = useState([])
    const [isPhone, setIsPhone] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const [lock, setLock] = useState(true);
    const [hide, setHide] = useState({
            serial: false,
            cat: false
        })
    
    // duration to release the invoice
    const fallbackDuartion = 1500;

    useEffect(() => {
        const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);
        setIsPhone(isMobile);
    }, [isPhone]);

    useEffect(() => {
        setIsDesktop(!!window.electronAPI?.isElectron);
    }, []);

    // set device key to open system
    useEffect(() => {
        localStorage.setItem("dev_id_sys", devKey);
    }, [devKey]);

    useEffect(() => {
        localStorage.setItem("lang", language);
    }, [language]);

    const parent = {
        api,
        setStylingNav,
        stylingNav,
        page,
        setPage,
        lock, 
        setLock,
        hide, setHide,
        lessVisaMoney,
        setTablesAreCreated,
        tablesAreCreates,
        isPhone,
        devKey, 
        setDevKey,
        isDesktop,
        fallbackDuartion,
        language,
        setLanguage
    };
    
    return <config.Provider value={parent}>{children}</config.Provider>
}